import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-shopping-guide')!;

export default function ArticleShoppingGuidePage() {
  return <ArticleTemplate article={article} />;
}